<template>
  <div class="commission-tab-panel">
    <div class="commission-search">
      <input v-model="hostessId" maxlength="30" :placeholder="$t('lang.Invite.k055')" />
      <div class="search-divider"></div>
      <div class="search-btn" @click="handleSearch">{{ $t('lang.BaseModule.k052') }}</div>
    </div>

    <div class="period-switch-tab">
      <div class="period-tab" :class="{ 'active-tab': tabIndex === 0 }" @click="changeTab(0)">{{ $t('lang.Invite.k001') }}</div>
      <div class="period-tab" :class="{ 'active-tab': tabIndex === 1 }" @click="changeTab(1)">{{ $t('lang.Invite.k009') }}</div>
      <div class="period-tab" :class="{ 'active-tab': tabIndex === 2 }" @click="changeTab(2)">{{ $t('lang.Invite.k005') }}</div>
    </div>

    <!-- Monthly -->
    <div v-if="tabIndex === 0" class="sub-period-tab">
      <div class="sub-period-item" :class="{ 'active-tab': monthSelected === 1 }" @click="selectMonth(1)">{{ $t('lang.Invite.k002') }}</div>
      <div class="sub-period-item" :class="{ 'active-tab': monthSelected === 2 }" @click="selectMonth(2)">{{ $t('lang.Invite.k003') }}</div>
    </div>

    <!-- Weekly -->
    <div v-if="tabIndex === 1" class="sub-period-tab">
      <div class="sub-period-item" :class="{ 'active-tab': weekSelected === 1 }" @click="selectWeek(1)">{{ $t('lang.Invite.k105') }}</div>
      <div class="sub-period-item" :class="{ 'active-tab': weekSelected === 2 }" @click="selectWeek(2)">{{ $t('lang.Invite.k106') }}</div>
    </div>

    <!-- Daily -->
    <div v-if="tabIndex === 2" class="day-picker" @click="selectDay">
      <span class="day-text">{{ handleMoment(chooseTime, 'DD MMM YYYY') }}</span>
      <img class="day-arrow ar-arrow" src="@/assets/packageAssets/common/arrow13.webp" alt="" />
    </div>

    <div class="amount-block">
      <div class="amount-item">
        <div class="amount-count">
          <img :src="getMatchImg('beans')" alt="" />
          <span>{{ thousandthDigit(hostIncomeSum) }}</span>
        </div>
        <div class="amount-title-row">
          <div class="amount-title">{{ $t('lang.Invite.k071') }}</div>
          <CTipPopover v-model="showCommissionTip" placement="bottom">
            <template #trigger>
              <img class="info-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp" alt="" />
            </template>
            {{ $t('lang.Invite.k072') }}
          </CTipPopover>
        </div>
      </div>
    </div>

    <div class="income-panel">
      <div class="income-header">
        <div class="cell cell-account">{{ $t('lang.BaseModule.k001') }}</div>
        <div class="cell cell-commission">
          {{ $t('lang.BaseModule.k014') }}
          <img :src="getMatchImg('beans')" alt="" />
        </div>
        <div class="cell cell-income">
          {{ $t('lang.BaseModule.k030') }}
          <img :src="getMatchImg('beans')" alt="" />
        </div>
      </div>

      <div class="income-row" v-for="(item, index) in listData" :key="index">
        <div class="cell cell-account">
          <div class="account-name">
            <span class="name-text">{{ item.nickname }}</span>
            <img class="country-icon" :src="item.locationFlag | imgPath" alt="" />
          </div>
          <div class="account-id" @click="handleCopy(item.presentId, $t('lang.BaseModule.k070'))">
            <span>ID:{{ item.presentId }}</span>
            <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
          </div>
        </div>
        <div class="cell cell-commission">{{ thousandthDigit(item.hostIncomeCommission) }}</div>
        <div class="cell cell-income">{{ thousandthDigit(item.hostIncome) }}</div>
      </div>
      <div v-if="!listData.length && !loading" class="table-empty"></div>
    </div>

    <div v-if="loading" class="is-loading">
      <van-loading size="24px" />
    </div>

    <div v-if="finished && listData.length" class="no-more">{{ $t('lang.Invite.k101') }}</div>

    <CTimeDay :showPop="showPop" :minDate="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchMonthIncome, apiFetchWeekIncome, apiFetchDailyIncome } from '@/api/imee'

import CTimeDay from '@/components/CTimeDay'
import moment from 'moment'
import eventBus from '@/utils/eventbus'

export default {
  components: { CTimeDay },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      },
    },
  },
  data() {
    return {
      tabIndex: 0,
      hostessId: '',
      limit: 10,
      offset: 0,
      loading: false,
      finished: false,
      monthSelected: 1,
      weekSelected: 1,
      chooseTime: new Date(),
      showPop: false,
      minDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
      listData: [],
      monthData: {},
      weekData: {},
      dayData: {},
      showCommissionTip: false,
    }
  },
  computed: {
    activeData() {
      if (this.tabIndex === 0) return this.monthData
      if (this.tabIndex === 1) return this.weekData
      if (this.tabIndex === 2) return this.dayData
      return {}
    },
    hostIncomeSum() {
      const data = this.activeData
      return data.hostIncomeSum ?? '-'
    },
    // totalCommission() {
    //   const data = this.activeData
    //   return data.totalCommission ?? '-'
    // },
  },
  methods: {
    getNativeScroll() {
      let parent = this.$parent
      while (parent) {
        if (parent.nativeScroll) {
          return parent.nativeScroll
        }
        parent = parent.$parent
      }
      return null
    },
    handleSearch() {
      if (this.tabIndex === 0) {
        this.resetList()
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      if (this.tabIndex === 1) {
        this.resetList()
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      if (this.tabIndex === 2) {
        this.resetList()
        this.fetchDailyIncome(this.chooseTime)
      }
    },
    resetList() {
      this.listData = []
      this.offset = 0
      this.loading = false
      this.finished = false
    },
    fetchMonthIncome(type) {
      if (this.loading || this.finished) return
      this.loading = true
      apiFetchMonthIncome({
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type,
      }).then((res) => {
        if (res) {
          this.monthData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.refresh()
          })
        }
      })
    },
    fetchWeekIncome(type) {
      if (this.loading || this.finished) return
      this.loading = true
      apiFetchWeekIncome({
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type,
      }).then((res) => {
        if (res) {
          this.weekData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.refresh()
          })
        }
      })
    },
    fetchDailyIncome(val) {
      if (this.loading || this.finished) return
      this.loading = true
      apiFetchDailyIncome({
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        agentDay: moment(val).format('yyyy-MM-DD'),
      }).then((res) => {
        if (res) {
          this.dayData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.refresh()
          })
        }
      })
    },
    changeTab(tabIndex) {
      this.tabIndex = tabIndex
      this.showPop = false
      this.showCommissionTip = false
      this.resetList()

      if (tabIndex === 0) {
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      if (tabIndex === 1) {
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      if (tabIndex === 2) {
        this.fetchDailyIncome(this.chooseTime)
      }
    },
    selectMonth(type) {
      if (this.monthSelected === type) return
      this.monthSelected = type
      this.resetList()
      this.fetchMonthIncome(type)
    },
    selectWeek(type) {
      if (this.weekSelected === type) return
      this.weekSelected = type
      this.resetList()
      this.fetchWeekIncome(type)
    },
    selectDay() {
      this.showPop = true
    },
    handleCurrentDate(val) {
      this.chooseTime = val
      this.resetList()
      this.fetchDailyIncome(this.chooseTime)
    },
    closePop() {
      this.showPop = false
    },
    scrollEvent(arg) {
      if (arg.type === 'arriveBottom') {
        if (this.tabIndex === 0) {
          this.fetchMonthIncome(this.monthSelected)
        } else if (this.tabIndex === 1) {
          this.fetchWeekIncome(this.weekSelected)
        } else if (this.tabIndex === 2) {
          this.fetchDailyIncome(this.chooseTime)
        }
      }
    },
  },
  created() {
    eventBus.$on('InviteScroll', this.scrollEvent)
    this.fetchMonthIncome(this.monthSelected)
  },
  beforeDestroy() {
    eventBus.$off('InviteScroll', this.scrollEvent)
  },
}
</script>

<style lang="scss" scoped>
.commission-tab-panel {
  display: flex;
  flex-direction: column;
  width: 100%;

  .commission-search {
    margin-top: 4px;
    display: flex;
    align-items: center;
    width: 100%;
    background: #f6f6f5;
    border-radius: 8px;
    overflow: hidden;

    input {
      flex: 1;
      min-width: 0;
      height: 44px;
      padding: 0 12px;
      border: none;
      background: transparent;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #333333;

      &::placeholder {
        color: #cccccc;
      }
    }

    .search-divider {
      width: 1px;
      height: 16px;
      background: #d9d9d9;
      flex-shrink: 0;
    }

    .search-btn {
      padding: 12px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #cccccc;
      white-space: nowrap;
    }
  }

  .period-switch-tab {
    margin-top: 8px;
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #eeeeee;

    .period-tab {
      flex: 1;
      padding: 12px 0;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-16);
      line-height: var(--lh-title-20);
      color: #b2b2b2;
      text-align: center;
      white-space: nowrap;

      &.active-tab {
        color: #333333;
        border-bottom: 1px solid #333333;
        margin-bottom: -1px;
      }
    }
  }

  .sub-period-tab {
    margin-top: 8px;
    display: flex;
    align-items: center;
    width: 100%;

    .sub-period-item {
      padding: 8px 16px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #b2b2b2;
      white-space: nowrap;
      text-align: center;

      &.active-tab {
        background: #f1e8d9;
        border-radius: 36px;
        color: #925e0d;
      }
    }
  }

  .day-picker {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #f1e8d9;
    border-radius: 36px;
    padding: 8px;
    box-sizing: border-box;

    .day-text {
      flex: 1;
      min-width: 0;
      padding: 0 8px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #925e0d;
      text-align: center;
      white-space: nowrap;
    }

    .day-arrow {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      margin-inline-end: 8px;
    }
  }

  .amount-block {
    margin-top: 8px;
    position: relative;

    .amount-item {
      padding: 24px 12px;
    }

    .amount-count {
      display: flex;
      align-items: center;
      font-family: var(--number-font);
      font-weight: var(--fw-600);
      font-size: var(--fs-20);
      line-height: var(--lh-title-28);
      color: #333333;

      span {
        margin-inline-start: 2px;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }

    .amount-title-row {
      display: flex;
      align-items: center;

      .info-icon {
        margin-inline-start: 2px;
      }
    }

    .amount-title {
      margin-top: 0;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-body-18);
      color: #b2b2b2;
    }

    .info-icon {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  .income-panel {
    margin-top: 8px;
    border: 2px solid #f9f8f6;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    background: transparent;

    .income-header,
    .income-row {
      display: grid;
      grid-template-columns: 35% 35% 30%;
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 0;
    }

    .income-header .cell {
      padding: 8px 4px;
      background: #f9f8f6;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #925e0d;
      text-align: center;
      white-space: nowrap;

      img {
        width: 12px;
        height: 12px;
        margin-inline-start: 2px;
      }
    }

    .income-header .cell-income {
      border-inline-start: 1.5px solid #edeae3;
    }

    .income-header .cell-commission {
      border-inline-start: 1.5px solid #edeae3;
    }

    .income-row .cell {
      border-bottom: 1.5px solid #f9f8f6;
    }

    .income-row:last-child .cell {
      border-bottom: none;
    }

    .table-empty {
      min-height: 120px;
      background: #fefefe;
    }

    .cell-account {
      justify-content: start;
      flex-direction: column;
      align-items: start;
      padding: 8px 6px;

      .account-id {
        margin-top: 8px;
      }
    }

    .income-header .cell-account {
      align-items: center;
      justify-content: center;
      flex-direction: row;
      padding: 8px 4px;
    }

    .cell-income,
    .cell-commission {
      padding: 12px 4px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-label-16);
      color: #333333;
      text-align: center;
      align-self: stretch;
    }

    .account-name {
      display: inline-flex;
      align-items: center;
      max-width: 100%;
      min-width: 0;

      .country-icon {
        margin-inline-start: 2px;
      }

      .name-text {
        flex: 0 1 auto;
        max-width: 80px;
        text-overflow: ellipsis;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .country-icon {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 0.5px solid rgba(102, 102, 102, 0.1);
        flex-shrink: 0;
      }
    }

    .account-id {
      display: inline-flex;
      align-items: center;
      max-width: 100%;

      span {
        white-space: nowrap;
        overflow: visible;
      }

      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-label-16);
      color: #b2b2b2;

      .copy-icon {
        margin-inline-start: 2px;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }
    }
  }

  .is-loading {
    margin-top: 8px;
    padding: 10px 0;
    text-align: center;
  }

  .no-more {
    margin-top: 8px;
    padding: 12px 10px;
  }
}
</style>
